export default "/images/vendor/flag-icon-css/flags/4x3/om.svg?716feea54634c16f406a0bdd4efa9b21";